<template>
  <div class="min-h-screen bg-white">
    <section class="pt-6 pb-16 text-white relative overflow-hidden bg-top bg-cover bg-slate-900" :style="heroStyle">
      <div class="absolute inset-0 opacity-[0.04]">
        <svg class="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="hero-grid" width="48" height="48" patternUnits="userSpaceOnUse">
              <path d="M 48 0 L 0 0 0 48" fill="none" stroke="white" stroke-width="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hero-grid)" />
        </svg>
      </div>

      <div class="relative container-custom">
        <div class="flex flex-wrap items-center justify-between gap-3 text-sm">
          <span
            class="inline-flex items-center gap-2 px-3 py-1 text-xs font-semibold tracking-wider uppercase text-kali-gold rounded-full border border-kali-gold/30 bg-kali-gold/10 backdrop-blur-sm">
            <svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z"
                clip-rule="evenodd" />
            </svg>
            Certificado Digital ICP-Brasil
          </span>

          <div class="flex items-center gap-3">
            <a :href="portalUrl" target="_blank" rel="noopener"
              class="inline-flex items-center gap-1.5 bg-white/10 hover:bg-white/20 border border-white/20 rounded-full px-3.5 py-1.5 text-white backdrop-blur-sm shadow-sm transition">
              <UserCircleIcon class="w-4 h-4" />
              Meus pedidos
            </a>
            <button @click="openOrder(null)"
              class="relative inline-flex items-center gap-1.5 bg-white/10 hover:bg-white/20 border border-white/20 rounded-full px-3.5 py-1.5 text-white backdrop-blur-sm shadow-sm transition">
              <ShoppingCartIcon class="w-4 h-4" />
              Carrinho
              <span v-if="!cartIsEmpty"
                class="absolute -top-1.5 -right-1.5 bg-kali-gold text-slate-900 text-[10px] font-bold rounded-full h-[18px] min-w-[18px] flex items-center justify-center px-1">
                {{ cartCount }}
              </span>
            </button>
          </div>
        </div>

        <div class="max-w-3xl">
          <h1 class="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">
            Emita NF-e, acesse a Receita Federal e assine documentos com
            <span class="text-kali-gold">segurança total</span>
          </h1>
          <p class="mt-3 text-base sm:text-lg text-slate-200 leading-relaxed max-w-xl">Certificado Digital e-CPF e
            e-CNPJ A1 para pessoas físicas e empresas. Emissão 100% online, suporte especializado e validade jurídica
            garantida.</p>

          <ul class="mt-4 space-y-1.5 text-sm">
            <li class="flex items-center gap-1.5">
              <span
                class="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-emerald-500/20 text-emerald-300 text-[10px] font-bold">✓</span>
              <span class="text-slate-200">Emissão rápida e 100% online</span>
            </li>
            <li class="flex items-center gap-1.5">
              <span
                class="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-emerald-500/20 text-emerald-300 text-[10px] font-bold">✓</span>
              <span class="text-slate-200">Suporte na instalação e primeiro uso</span>
            </li>
            <li class="flex items-center gap-1.5">
              <span
                class="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-emerald-500/20 text-emerald-300 text-[10px] font-bold">✓</span>
              <span class="text-slate-200">Parceria com Autoridade Certificadora homologada</span>
            </li>
          </ul>

          <div class="mt-6 flex flex-col sm:flex-row gap-4">
            <button @click="openOrder(null)" class="btn-primary text-base px-8 py-3.5 hover:scale-105">Comprar
              agora</button>
            <a href="#comparar-certificados"
              class="inline-flex items-center justify-center px-6 py-3.5 text-base font-semibold rounded-lg border border-slate-500 text-slate-200 hover:bg-white/10 transition-all duration-200">
              Ver planos e preços </a>
          </div>

          <div class="mt-4 flex items-center gap-4 text-xs text-slate-400">
            <span class="flex items-center gap-1.5">
              <svg class="w-4 h-4 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd" />
              </svg>
              Compra segura
            </span>
            <span class="flex items-center gap-1.5">
              <svg class="w-4 h-4 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd" />
              </svg>
              PIX ou boleto
            </span>
          </div>
        </div>
      </div>
    </section>

    <section id="comparar-certificados" class="section-padding bg-gray-50 scroll-mt-20">
      <div class="container-custom">
        <div class="text-center max-w-3xl mx-auto">
          <h2
            class="text-4xl sm:text-5xl font-black tracking-tight !leading-[1.25] pb-2 text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-[#006086] to-[#004d6b]">
            Escolha o certificado ideal</h2>
          <p class="mt-3 text-gray-600 text-base sm:text-lg">Atendemos pessoas físicas e jurídicas com certificados
            ICP-Brasil para emissão de NF-e, acesso a sistemas governamentais e assinatura de documentos.</p>
        </div>

        <div class="mt-12 grid gap-8 lg:grid-cols-2 max-w-4xl mx-auto">
          <div
            class="rounded-2xl shadow-lg overflow-hidden flex flex-col border-2 border-gray-200 hover:border-kali-blue-300 transition-all duration-200">
            <div class="bg-gradient-to-r from-[#006086] to-[#004a60] px-6 py-4">
              <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <h3 class="text-xl font-extrabold text-white">e-CNPJ A1</h3>
                <span class="inline-flex w-fit shrink-0 whitespace-nowrap text-xs font-bold px-2.5 py-1 rounded-full bg-white/20 text-white">Pessoa Jurídica</span>
              </div>
            </div>
            <div class="p-6 flex-1 flex flex-col">
              <p class="text-gray-600 text-sm">Para empresas que emitem NF-e e precisam acessar portais governamentais.
              </p>

              <div class="mt-5 flex items-baseline gap-3">
                <span v-if="ecnpj?.promo_active" class="text-sm text-gray-500 line-through">{{ formatPrice(ecnpj.price)
                  }}</span>
                <span class="text-3xl font-extrabold text-kali-blue-600">{{ ecnpjDisplay }}</span>
              </div>
              <p v-if="ecnpj?.promo_active" class="mt-1 text-xs text-orange-600 font-medium">
                Promoção válida até
                {{ new Date(ecnpj.promo_end_date).toLocaleDateString("pt-BR") }}
              </p>

              <ul class="mt-5 space-y-2.5 text-sm text-gray-700 flex-1">
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>Emissão de NF-e, NFS-e e CT-e</span>
                </li>
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>Acesso ao e-CAC e Receita Federal</span>
                </li>
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>Envio de declarações e obrigações fiscais</span>
                </li>
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>Assinatura de documentos digitais</span>
                </li>
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>e-Social e Conectividade Social</span>
                </li>
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>Validade de 12 meses</span>
                </li>
              </ul>

              <div class="mt-6 grid grid-cols-2 gap-3 text-center text-xs">
                <div class="rounded-xl bg-gray-50 border border-gray-100 p-3">
                  <div class="font-semibold text-gray-900">Armazenamento</div>
                  <div class="mt-0.5 text-gray-600">Arquivo (A1)</div>
                </div>
                <div class="rounded-xl bg-gray-50 border border-gray-100 p-3">
                  <div class="font-semibold text-gray-900">Mídia</div>
                  <div class="mt-0.5 text-gray-600">Sem token</div>
                </div>
              </div>

              <button @click="openOrder('ecnpj-a1')"
                class="mt-6 w-full inline-flex items-center justify-center px-5 py-3 rounded-lg text-base font-semibold bg-kali-blue-600 text-white hover:bg-kali-blue-700 transition-all duration-200 shadow-md hover:shadow-lg">Comprar
                e-CNPJ A1</button>
            </div>
          </div>

          <div
            class="rounded-2xl shadow-lg overflow-hidden flex flex-col border-2 border-kali-blue-300 ring-2 ring-kali-blue-100 relative">
            <div class="bg-gradient-to-r from-kali-gold to-[#d5ac2f] px-6 py-4">
              <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex flex-wrap items-center gap-3">
                  <h3 class="text-xl font-extrabold text-[#003e4d]">e-CPF A1</h3>
                  <span class="badge-gold text-[10px] px-2 py-0.5 shadow-sm">INDICADO</span>
                </div>
                <span class="inline-flex w-fit shrink-0 whitespace-nowrap text-xs font-bold px-2.5 py-1 rounded-full bg-[#003e4d]/15 text-[#003e4d]">Pessoa
                  Física</span>
              </div>
            </div>
            <div class="p-6 flex-1 flex flex-col">
              <p class="text-gray-600 text-sm">Para sócios, contadores e profissionais liberais.</p>

              <div class="mt-5 flex items-baseline gap-3">
                <span v-if="ecpf?.promo_active" class="text-sm text-gray-500 line-through">{{ formatPrice(ecpf.price)
                  }}</span>
                <span class="text-3xl font-extrabold text-kali-blue-600">{{ ecpfDisplay }}</span>
              </div>
              <p v-if="ecpf?.promo_active" class="mt-1 text-xs text-orange-600 font-medium">
                Promoção válida até
                {{ new Date(ecpf.promo_end_date).toLocaleDateString("pt-BR") }}
              </p>

              <ul class="mt-5 space-y-2.5 text-sm text-gray-700 flex-1">
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>Assinatura digital de contratos e documentos</span>
                </li>
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>Acesso à Receita Federal e e-CAC</span>
                </li>
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>Envio de declaração de Imposto de Renda</span>
                </li>
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>Uso em e-Social e Conectividade Social</span>
                </li>
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>Acesso a bancos públicos e privados</span>
                </li>
                <li class="flex items-start gap-2.5">
                  <span class="text-emerald-500 mt-0.5 shrink-0" aria-hidden="true">✓</span>
                  <span>Validade de 12 meses</span>
                </li>
              </ul>

              <div class="mt-6 grid grid-cols-2 gap-3 text-center text-xs">
                <div class="rounded-xl bg-gray-50 border border-gray-100 p-3">
                  <div class="font-semibold text-gray-900">Armazenamento</div>
                  <div class="mt-0.5 text-gray-600">Arquivo (A1)</div>
                </div>
                <div class="rounded-xl bg-gray-50 border border-gray-100 p-3">
                  <div class="font-semibold text-gray-900">Mídia</div>
                  <div class="mt-0.5 text-gray-600">Sem token</div>
                </div>
              </div>

              <button @click="openOrder('ecpf-a1')"
                class="mt-6 w-full inline-flex items-center justify-center px-5 py-3 rounded-lg text-base font-semibold bg-kali-gold text-[#003e4d] hover:bg-[#d5ac2f] transition-all duration-200 shadow-md hover:shadow-lg">Comprar
                e-CPF A1</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-padding bg-white">
      <div class="container-custom">
        <div class="text-center">
          <h2
            class="text-4xl sm:text-5xl font-black tracking-tight !leading-[1.25] pb-2 text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-[#006086] to-[#004d6b] lg:whitespace-nowrap">
            Por que emitir com a Kali Sistemas?</h2>
          <p class="mt-3 text-gray-600 text-base sm:text-lg max-w-3xl mx-auto">Atendimento de ponta a ponta: da escolha
            do certificado até a instalação e uso.</p>
        </div>

        <div class="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          <div v-for="benefit in benefits" :key="benefit.title"
            class="rounded-2xl bg-white border border-gray-200 p-6 transition-all duration-200 hover:border-kali-blue-200 hover:shadow-md">
            <component :is="benefit.icon" class="w-10 h-10 text-[#006086]" />
            <h3 class="mt-4 text-lg font-bold text-gray-900">
              {{ benefit.title }}
            </h3>
            <p class="mt-2 text-sm text-gray-600 leading-relaxed">
              {{ benefit.description }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section-padding bg-gray-50">
      <div class="container-custom">
        <div class="text-center max-w-3xl mx-auto">
          <h2
            class="text-4xl sm:text-5xl font-black tracking-tight !leading-[1.25] pb-2 text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-[#006086] to-[#004d6b]">
            Como funciona em 4 passos</h2>
          <p class="mt-3 text-gray-600 text-base sm:text-lg">Um processo simples, com orientação em cada etapa.</p>
        </div>

        <div class="mt-12 grid gap-6 lg:grid-cols-4">
          <div v-for="step in steps" :key="step.number" v-reveal
            :style="{ transitionDelay: (step.number - 1) * 120 + 'ms' }"
            class="relative rounded-2xl border border-gray-200 bg-white p-6 text-center">
            <div
              class="mx-auto h-12 w-12 rounded-full flex items-center justify-center text-lg font-extrabold bg-kali-blue-100 text-kali-blue-700">
              {{ step.number }}
            </div>
            <h3 class="mt-4 text-base font-bold text-gray-900">
              {{ step.title }}
            </h3>
            <p class="mt-2 text-sm text-gray-600 leading-relaxed">
              {{ step.description }}
            </p>
            <div v-if="step.number < 4" class="hidden lg:block absolute top-12 -right-3 w-6 text-gray-300"
              aria-hidden="true">→</div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-padding bg-white">
      <div class="container-custom">
        <div class="text-center max-w-3xl mx-auto">
          <h2
            class="text-4xl sm:text-5xl font-black tracking-tight !leading-[1.25] pb-2 text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-[#006086] to-[#004d6b]">
            Quem usa o Certificado Digital</h2>
          <p class="mt-3 text-gray-600 text-base sm:text-lg">Ideal para quem precisa emitir documentos fiscais, acessar
            portais oficiais e assinar documentos digitais com validade jurídica.</p>
        </div>

        <div class="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          <div v-for="profile in profiles" :key="profile.title"
            class="rounded-2xl border border-gray-200 bg-white p-6 transition-all duration-200 hover:border-kali-blue-200 hover:shadow-md">
            <component :is="profile.icon" class="w-9 h-9 text-[#006086]" />
            <h3 class="mt-3 text-base font-bold text-gray-900">
              {{ profile.title }}
            </h3>
            <p class="mt-2 text-sm text-gray-600 leading-relaxed">
              {{ profile.description }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <FaqPanel :items="faqs" title="Perguntas frequentes sobre Certificado Digital"
      description="Dúvidas sobre certificado digital? Veja as respostas e fale com nosso time."
      cta-label="Falar com um consultor" :cta-opens-modal="true" section-class="bg-gray-50" />

    <section class="relative overflow-hidden bg-gradient-to-r from-[#006086] to-[#004d6b]">
      <div class="absolute inset-0">
        <svg class="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice"
          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1463 360">
          <path class="text-[#004d6b] text-opacity-40" fill="currentColor"
            d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z" />
          <path class="text-[#003d56] text-opacity-40" fill="currentColor"
            d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z" />
        </svg>
      </div>

      <div class="relative max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
        <div class="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div>
            <h2 class="text-4xl font-extrabold tracking-tight !leading-[1.2] pb-2 text-white sm:text-5xl">
              <span class="block sm:hidden">Pronto para emitir com</span>
              <span class="block sm:hidden bg-clip-text text-transparent bg-gradient-to-r from-[#e6f0f4] to-[#007ba8]">
                segurança e validade
              </span>
              <span class="block sm:hidden bg-clip-text text-transparent bg-gradient-to-r from-[#e6f0f4] to-[#007ba8]">
                jurídica?
              </span>
              <span class="hidden sm:block">Pronto para emitir com</span>
              <span class="hidden sm:block bg-clip-text text-transparent bg-gradient-to-r from-[#e6f0f4] to-[#007ba8]">
                segurança e validade jurídica?
              </span>
            </h2>
            <p class="mt-4 text-lg text-[#e6f0f4] max-w-3xl">
              Conte com a Kali Sistemas para escolher o certificado ideal,
              concluir a validação e receber suporte no primeiro uso.
            </p>
          </div>

          <div class="mt-12 lg:mt-0">
            <div class="space-y-4 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-4 lg:gap-6">
              <button type="button" @click="openOrder(null)"
                class="flex items-center justify-center px-6 py-4 border-2 border-white text-xl font-medium rounded-xl text-[#006086] bg-white hover:bg-[#e6f0f4] transition-colors duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-transform">
                Comprar agora
              </button>
              <button type="button" @click="openConsultorModal"
                class="flex items-center justify-center px-6 py-4 border-2 border-[#007ba8] text-xl font-medium rounded-xl text-white hover:bg-[#004d6b] transition-colors duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-transform">
                Falar com Consultor
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Modal de Pedido -->
    <CertificateOrderForm v-if="showOrderForm" :initial-type="orderType" @close="showOrderForm = false" />
  </div>
</template>

<script setup>
defineOptions({ name: "CertificadoDigitalPage" });
import { ref, computed, onMounted } from "vue";
import {
  UserCircleIcon,
  ShoppingCartIcon,
  UserGroupIcon,
  LinkIcon,
  BoltIcon,
  ShieldCheckIcon,
  ComputerDesktopIcon,
  CheckBadgeIcon,
  DocumentCheckIcon,
  BuildingOffice2Icon,
  CalculatorIcon,
  BriefcaseIcon,
} from "@heroicons/vue/24/outline";
import { useSeo } from "@/composables/useSeo";
import FaqPanel from "@/components/ui/FAQ.vue";
import CertificateOrderForm from "@/components/CertificateOrderForm.vue";
import { useCertificateCart } from "@/composables/useCertificateCart";
import api from "@/services/api";
import heroCerti from "@/assets/hero-certi.webp";

const portalUrl = import.meta.env?.VITE_PORTAL_URL || "https://portal.kalisistemas.com.br";

// Mesmo esquema de overlay do SegmentHero (overlay-variant="left"): escurece a
// esquerda pra legibilidade do texto e deixa a foto aparecer mais à direita.
const heroStyle = computed(() => ({
  backgroundImage: `linear-gradient(to right, rgba(15,23,42,0.88) 0%, rgba(15,23,42,0.74) 35%, rgba(15,23,42,0.35) 60%, rgba(15,23,42,0) 82%), url(${heroCerti})`,
}));

const { items: cartItems, isEmpty: cartIsEmpty } = useCertificateCart();
const cartCount = computed(() => cartItems.value.reduce((sum, i) => sum + i.quantity, 0));

const showOrderForm = ref(false);
const orderType = ref(null);

function openOrder(type) {
  orderType.value = type;
  showOrderForm.value = true;
}

// Revela o elemento com fade+slide assim que ele entra na viewport ao rolar a página.
const vReveal = {
  mounted(el) {
    el.classList.add("reveal-init");
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("reveal-visible");
          io.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" },
    );
    io.observe(el);
  },
};

const products = ref([]);

onMounted(async () => {
  if (import.meta.env.SSR) return;
  try {
    const { data } = await api.get("/public/certificate-products");
    products.value = Array.isArray(data) ? data : [];
  } catch {
    // catálogo indisponível — mantém a lista vazia em vez de quebrar a página
  }
});

const ecnpj = computed(() => products.value.find((p) => p.id === "ecnpj-a1"));
const ecpf = computed(() => products.value.find((p) => p.id === "ecpf-a1"));

function formatPrice(v) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(v);
}

const ecnpjDisplay = computed(() => (ecnpj.value?.promo_active ? formatPrice(ecnpj.value.promo_price) : formatPrice(ecnpj.value?.price ?? 235.0)));

const ecpfDisplay = computed(() => (ecpf.value?.promo_active ? formatPrice(ecpf.value.promo_price) : formatPrice(ecpf.value?.price ?? 160.0)));

useSeo({
  title: "Certificado Digital A1 para Empresas e Pessoa Física | Kali Sistemas",
  description: "Emita NF-e, acesse a Receita Federal e assine documentos digitais com segurança. Certificado Digital e-CPF e e-CNPJ A1 com suporte completo da Kali Sistemas.",
  schema: {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "Certificado Digital A1 - e-CPF / e-CNPJ",
    description: "Certificado Digital A1 para pessoa física (e-CPF) e pessoa jurídica (e-CNPJ). Emissão 100% online com suporte completo.",
    brand: {
      "@type": "Organization",
      name: "Kali Sistemas",
    },
    offers: [
      {
        "@type": "Offer",
        name: "e-CNPJ A1",
        price: "235.00",
        priceCurrency: "BRL",
        availability: "https://schema.org/InStock",
      },
      {
        "@type": "Offer",
        name: "e-CPF A1",
        price: "160.00",
        priceCurrency: "BRL",
        availability: "https://schema.org/InStock",
      },
    ],
  },
});

const whatsAppHelpLink = "https://wa.me/5579991389415?text=" + encodeURIComponent("Olá! Tenho dúvidas sobre Certificado Digital (e-CNPJ/e-CPF A1). Pode me ajudar?");

const openConsultorModal = () => {
  window.dispatchEvent(new CustomEvent("open-consultor-modal"));
};

const benefits = [
  {
    icon: UserGroupIcon,
    title: "Atendimento humanizado",
    description: "Suporte feito por especialistas que conhecem a realidade das empresas brasileiras.",
  },
  {
    icon: LinkIcon,
    title: "Integração com sistemas",
    description: "Certificados prontos para uso em sistemas fiscais, contábeis e de gestão empresarial.",
  },
  {
    icon: BoltIcon,
    title: "Processo rápido",
    description: "Orientamos desde a compra até a emissão para você não perder tempo com burocracia.",
  },
  {
    icon: ShieldCheckIcon,
    title: "Segurança e conformidade",
    description: "Seguimos as normas da ICP-Brasil e as melhores práticas de segurança da informação.",
  },
  {
    icon: ComputerDesktopIcon,
    title: "Suporte na instalação",
    description: "Ajudamos na instalação em computadores, servidores e sistemas de emissão de NF-e.",
  },
  {
    icon: CheckBadgeIcon,
    title: "Pronto para usar",
    description: "Após a emissão, você pode começar imediatamente a assinar e acessar portais públicos.",
  },
];

const steps = [
  {
    number: 1,
    title: "Escolha o certificado",
    description: "Selecione e-CPF ou e-CNPJ A1 e finalize a compra na Kali Sistemas.",
  },
  {
    number: 2,
    title: "Envie sua documentação",
    description: "Você recebe orientações claras sobre os documentos necessários e como enviá-los.",
  },
  {
    number: 3,
    title: "Faça a validação",
    description: "Agende sua validação online para confirmar sua identidade de forma segura.",
  },
  {
    number: 4,
    title: "Instale e comece a usar",
    description: "Emitimos o certificado e auxiliamos na instalação. Pronto para emitir NF-e!",
  },
];

const profiles = [
  {
    icon: DocumentCheckIcon,
    title: "Empresas que emitem NF-e",
    description: "Comércio, serviços, indústrias e qualquer empresa que precise emitir nota fiscal eletrônica.",
  },
  {
    icon: BuildingOffice2Icon,
    title: "MEI e pequenas empresas",
    description: "Negócios que estão crescendo e precisam organizar a emissão de documentos fiscais.",
  },
  {
    icon: CalculatorIcon,
    title: "Contadores e escritórios",
    description: "Profissionais que cuidam da parte fiscal e tributária de vários clientes.",
  },
  {
    icon: BriefcaseIcon,
    title: "Profissionais liberais",
    description: "Médicos, advogados, consultores e outros que assinam contratos e documentos digitais.",
  },
];

const faqs = [
  {
    question: "O que é um Certificado Digital A1?",
    answer: "É um arquivo digital instalado no computador que funciona como uma identidade eletrônica para pessoas físicas (e-CPF) ou jurídicas (e-CNPJ). Ele garante a autenticidade e a validade jurídica de operações online, como emissão de notas fiscais e assinatura de documentos.",
  },
  {
    question: "Qual a diferença entre e-CPF e e-CNPJ?",
    answer: "O e-CPF identifica uma pessoa física, como o sócio ou responsável da empresa. O e-CNPJ identifica a própria empresa (pessoa jurídica) em ambientes eletrônicos, sendo usado principalmente para emitir NF-e e cumprir obrigações fiscais.",
  },
  {
    question: "Vou precisar de token ou cartão?",
    answer: "No certificado A1, não. Ele é armazenado como um arquivo no computador ou servidor, dispensando o uso de mídia física.",
  },
  {
    question: "Quanto tempo leva para começar a usar?",
    answer: "Depois da compra e do envio correto dos documentos, o prazo depende da validação. Após a validação, o certificado é emitido e instalado geralmente no mesmo dia.",
  },
  {
    question: "Vocês ajudam na instalação?",
    answer: "Sim. Oferecemos orientação e suporte para instalação e configuração do certificado nos principais sistemas de emissão de NF-e e portais oficiais.",
  },
  {
    question: "O certificado vale por quanto tempo?",
    answer: "O Certificado Digital A1 tem validade de 1 ano. Antes do vencimento, avisamos para que você possa renovar sem interromper suas operações.",
  },
  {
    question: "Quais formas de pagamento são aceitas?",
    answer: "Aceitamos PIX e boleto bancário.",
  },
];
</script>

<style scoped>
.reveal-init {
  opacity: 0;
  transform: translateY(28px);
  transition:
    opacity 0.6s ease-out,
    transform 0.6s ease-out;
}

.reveal-visible {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .reveal-init {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
</style>
